<script setup lang="ts">
definePageMeta({
  layout: 'search',
})

useSetSEO()
useScrollRestoration()
</script>

<template>
  <NovaSearchResultDetailPost />
</template>

<style lang="scss" scoped></style>
